<template>
  <div class="cooperation">
    <div class="title">
      {{ $theme ? '产学研合作' : 'INDUSTRY-UNIVERSITY-RESEARCH COOPERATION' }}
    </div>
    <div class="subtitle">{{
        $theme ? '与国内顶级院校、世界级企业强强联手，产学研结合带动科研储' : 'Cooperate with top domestic universities and world-class enterprises to promote scientific research and development'
      }}
    </div>
    <div class="list" :style="{transform: 'scale('+(multiple<1?multiple:1)+')'}">
      <img :class="`border${active?' active':''}`" src="@/assets/img/brand-honor/cooperation/border.png">
      <!--      <div class="inner">-->
      <!--        <img-->
      <!--            v-for="item in list"-->
      <!--            :key="item.id"-->
      <!--            :class="`item ${active === item.id?'active':''}`"-->
      <!--            :style="{order: getOrder(item.id)}"-->
      <!--            :src="require(`@/assets/img/brand-honor/cooperation/${item.name}.png`)"-->
      <!--            @click="onClick(item)"-->
      <!--        />-->
      <!--      </div>-->
      <el-carousel :autoplay="false" type="card" height="617px" @change="carouselChange" ref="carousel">
        <el-carousel-item v-for="item in list"
                          :key="item.id" :ref="'card'+item.id">
          <img :src="require(`@/assets/img/brand-honor/cooperation/${$theme?'':'eng/'}${item.name}.png`)">
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cooperation',
  components: {},
  data() {
    return {
      carouseId: 0,
      active: 1,
      list: [
        {
          id: 1,
          name: '北理工'
        },
        {
          id: 2,
          name: '清华'
        },
        {
          id: 3,
          name: '戴尔'
        }
        // ,{
        //   id: 4,
        //   name: '北理工'
        // },
        // {
        //   id: 5,
        //   name: '清华'
        // },
        // {
        //   id: 6,
        //   name: '戴尔'
        // }
      ],
      multiple: 1
    }
  },
  methods: {
    onWindowResize() {
      const width = document.body.clientWidth;
      this.multiple = width / 1920
    },
    getOrder(id) {
      let order = 0
      if (id === this.active) {
        order = 1
      } else if (id < this.active) {
        if (id === this.active - 2) {
          order = 2
        } else {
          order = 0
        }
      } else {
        if (id === this.active + 1) {
          order = 2
        } else {
          order = 0
        }
      }
      return order
    },
    onClick(item) {
      // this.active = ''
      // setTimeout(() => {
      this.active = item.id
      // }, 1000)
    },
    carouselChange(now, old) {
      this.carouseId = now;
      this.setPY();
    },
    setPY() {
      const {carouseId} = this
      if (carouseId === 0) {
        this.$refs["card1"][0].$el.style.left = '-1.2%';
        this.$refs["card2"][0].$el.style.left = '24%';
        this.$refs["card3"][0].$el.style.left = '-15%';
        this.$refs["card1"][0].$el.style.top = '0';
        this.$refs["card2"][0].$el.style.top = '13%';
        this.$refs["card3"][0].$el.style.top = '13%';
      } else if (carouseId === 1) {
        this.$refs["card2"][0].$el.style.left = '-1.2%';
        this.$refs["card3"][0].$el.style.left = '24%';
        this.$refs["card1"][0].$el.style.left = '-15%';
        this.$refs["card2"][0].$el.style.top = '0';
        this.$refs["card3"][0].$el.style.top = '13%';
        this.$refs["card1"][0].$el.style.top = '13%';
      } else {
        this.$refs["card3"][0].$el.style.left = '-1.2%';
        this.$refs["card1"][0].$el.style.left = '24%';
        this.$refs["card2"][0].$el.style.left = '-15%';
        this.$refs["card3"][0].$el.style.top = '0';
        this.$refs["card1"][0].$el.style.top = '13%';
        this.$refs["card2"][0].$el.style.top = '13%';
      }
    },
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize, false)
    this.$nextTick(() => {
      this.onWindowResize()
    })
    // console.log(this.$refs["carousel"])
    this.setPY()
  }
}
</script>
<style lang="scss" scoped>
@import './Index.scss';

::v-deep .el-carousel__arrow {
  display: none !important;
}
</style>
